import mockLocations from '@/components/dash/presence-management/mockLocations.json'
import axios from 'axios'

const DAY_ORDER = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
]

export function computeCompletionAudit(location) {
  const network = (location?.network || (Array.isArray(location?.networks) && location.networks[0]) || 'google').toLowerCase()

  let CRITERIA = []

  if (network === 'instagram') {
    CRITERIA = [
      {
        key: 'username',
        labelKey: 'dash.presenceManagement.score.items.username',
        defaultLabel: 'Identifiant (@username)',
        weight: 20,
        tab: 'profile',
        check: loc => !!(loc?.username || loc?.handle || loc?.raw?.username)
      },
      {
        key: 'title',
        labelKey: 'dash.presenceManagement.score.items.title',
        defaultLabel: 'Nom affiché',
        weight: 20,
        tab: 'profile',
        check: loc => !!(loc?.title || loc?.name || loc?.raw?.name)
      },
      {
        key: 'logo',
        labelKey: 'dash.presenceManagement.score.items.logo',
        defaultLabel: 'Photo de profil (Avatar)',
        weight: 20,
        tab: 'profile',
        check: loc => !!(loc?.avatar || loc?.imageUrl || loc?.profilePhoto || loc?.raw?.profile_picture_url)
      },
      {
        key: 'description',
        labelKey: 'dash.presenceManagement.score.items.bio',
        defaultLabel: 'Biographie (Bio)',
        weight: 15,
        tab: 'profile',
        check: loc => !!(loc?.profile?.description || loc?.biography || loc?.raw?.biography)
      },
      {
        key: 'website',
        labelKey: 'dash.presenceManagement.score.items.website',
        defaultLabel: 'Lien dans la bio (Site web)',
        weight: 15,
        tab: 'profile',
        check: loc => !!(loc?.websiteUri || loc?.website || loc?.raw?.website)
      },
      {
        key: 'category',
        labelKey: 'dash.presenceManagement.score.items.category',
        defaultLabel: 'Catégorie professionnelle',
        weight: 10,
        tab: 'activity',
        check: loc => !!(loc?.categories?.primaryCategory?.displayName || loc?.categories?.primaryCategory?.name || loc?.category || loc?.raw?.category)
      }
    ]
  } else if (network === 'facebook') {
    CRITERIA = [
      {
        key: 'title',
        labelKey: 'dash.presenceManagement.score.items.title',
        defaultLabel: 'Nom de la page',
        weight: 20,
        tab: 'profile',
        check: loc => !!(loc?.title || loc?.name || loc?.raw?.name)
      },
      {
        key: 'category',
        labelKey: 'dash.presenceManagement.score.items.category',
        defaultLabel: 'Catégorie principale',
        weight: 15,
        tab: 'activity',
        check: loc => !!(loc?.categories?.primaryCategory?.displayName || loc?.categories?.primaryCategory?.name || loc?.category || loc?.raw?.category)
      },
      {
        key: 'phone',
        labelKey: 'dash.presenceManagement.score.items.phone',
        defaultLabel: 'Numéro de téléphone',
        weight: 15,
        tab: 'profile',
        check: loc => !!(loc?.phoneNumbers?.primaryPhone || loc?.phone || loc?.raw?.phone)
      },
      {
        key: 'location',
        labelKey: 'dash.presenceManagement.score.items.address',
        defaultLabel: 'Adresse physique',
        weight: 15,
        tab: 'profile',
        check: loc => {
          const lines = loc?.storefrontAddress?.addressLines || []
          const hasStreet = lines.some(l => l && String(l).trim().length > 0)
          const hasCity = !!(loc?.storefrontAddress?.locality && String(loc.storefrontAddress.locality).trim().length > 0)
          const hasZip = !!(loc?.storefrontAddress?.postalCode && String(loc.storefrontAddress.postalCode).trim().length > 0)
          const hasRawStreet = !!(loc?.raw?.location && (loc.raw.location.street || loc.raw.location.city) && (String(loc.raw.location.street || '').trim().length > 0 || String(loc.raw.location.city || '').trim().length > 0))
          const hasAddrStr = !!(loc?.address && String(loc.address).trim().length > 0 && loc.address !== ', ')
          return hasStreet || hasCity || hasZip || hasRawStreet || hasAddrStr
        }
      },
      {
        key: 'regularHours',
        labelKey: 'dash.presenceManagement.score.items.regularHours',
        defaultLabel: 'Horaires d\'ouverture',
        weight: 15,
        tab: 'hours',
        check: loc => (loc?.regularHours?.periods || []).length > 0 || !!loc?.raw?.hours
      },
      {
        key: 'description',
        labelKey: 'dash.presenceManagement.score.items.description',
        defaultLabel: 'Description / À propos',
        weight: 10,
        tab: 'profile',
        check: loc => !!(loc?.profile?.description || loc?.about || loc?.raw?.about)
      },
      {
        key: 'logo',
        labelKey: 'dash.presenceManagement.score.items.logo',
        defaultLabel: 'Photo de profil',
        weight: 5,
        tab: 'profile',
        check: loc => !!(loc?.avatar || loc?.imageUrl || loc?.profilePhoto || loc?.raw?.picture)
      },
      {
        key: 'cover',
        labelKey: 'dash.presenceManagement.score.items.cover',
        defaultLabel: 'Photo de couverture',
        weight: 5,
        tab: 'profile',
        check: loc => !!(loc?.coverPhoto || loc?.coverImageUrl || loc?.raw?.cover)
      }
    ]
  } else if (network === 'apple') {
    CRITERIA = [
      {
        key: 'title',
        labelKey: 'dash.presenceManagement.score.items.title',
        defaultLabel: 'Nom de l\'établissement',
        weight: 20,
        tab: 'profile',
        check: loc => !!(loc?.title || loc?.name)
      },
      {
        key: 'category',
        labelKey: 'dash.presenceManagement.score.items.category',
        defaultLabel: 'Catégorie principale',
        weight: 20,
        tab: 'activity',
        check: loc => !!(loc?.categories?.primaryCategory?.displayName || loc?.categories?.primaryCategory?.name || loc?.category)
      },
      {
        key: 'location',
        labelKey: 'dash.presenceManagement.score.items.address',
        defaultLabel: 'Adresse physique',
        weight: 20,
        tab: 'profile',
        check: loc => {
          const a = loc?.storefrontAddress || loc?.address
          if (!a) return false
          if (typeof a === 'string') return a.trim().length > 0 && a.toLowerCase() !== 'sans adresse'
          return Array.isArray(a.addressLines) && a.addressLines.length > 0 && !!a.addressLines[0].trim()
        }
      },
      {
        key: 'phone',
        labelKey: 'dash.presenceManagement.score.items.phone',
        defaultLabel: 'Numéro de téléphone',
        weight: 15,
        tab: 'profile',
        check: loc => !!(loc?.phoneNumbers?.primaryPhone || loc?.phone)
      },
      {
        key: 'hours',
        labelKey: 'dash.presenceManagement.score.items.hours',
        defaultLabel: 'Horaires d\'ouverture',
        weight: 15,
        tab: 'hours',
        check: loc => {
          const periods = loc?.regularHours?.periods || []
          return Array.isArray(periods) && periods.length > 0
        }
      },
      {
        key: 'cover',
        labelKey: 'dash.presenceManagement.score.items.cover',
        defaultLabel: 'Photo de couverture (Bannière)',
        weight: 10,
        tab: 'profile',
        check: loc => !!(loc?.coverPhoto || loc?.coverImageUrl || loc?.media?.cover || loc?.raw?.cover)
      }
    ]
  } else {
    // GOOGLE (default)
    const isSAB = location?.serviceArea?.businessType === 'CUSTOMER_LOCATION_ONLY' || 
                  (!location?.storefrontAddress?.addressLines?.length && !!location?.serviceArea)

    CRITERIA = [
      {
        key: 'title',
        labelKey: 'dash.presenceManagement.score.items.title',
        defaultLabel: 'Nom de l\'établissement',
        weight: 15,
        tab: 'profile',
        check: loc => !!(loc?.title && loc.title.trim())
      },
      {
        key: 'category',
        labelKey: 'dash.presenceManagement.score.items.category',
        defaultLabel: 'Catégorie principale',
        weight: 15,
        tab: 'activity',
        check: loc => !!(loc?.categories?.primaryCategory?.displayName || loc?.categories?.primaryCategory?.name)
      },
      {
        key: 'phone',
        labelKey: 'dash.presenceManagement.score.items.phone',
        defaultLabel: 'Numéro de téléphone',
        weight: 15,
        tab: 'profile',
        check: loc => !!(loc?.phoneNumbers?.primaryPhone && loc.phoneNumbers.primaryPhone.trim())
      },
      {
        key: 'location',
        labelKey: isSAB ? 'dash.presenceManagement.score.items.serviceArea' : 'dash.presenceManagement.score.items.address',
        defaultLabel: isSAB ? 'Zone de chalandise' : 'Adresse physique',
        weight: 15,
        tab: 'profile',
        check: loc => {
          if (isSAB) {
            return !!(loc?.serviceArea && (loc.serviceArea.businessType || loc.serviceArea.places))
          }
          const lines = loc?.storefrontAddress?.addressLines || []
          const hasStreet = lines.some(l => l && String(l).trim().length > 0)
          const hasCity = !!(loc?.storefrontAddress?.locality && String(loc.storefrontAddress.locality).trim().length > 0)
          const hasZip = !!(loc?.storefrontAddress?.postalCode && String(loc.storefrontAddress.postalCode).trim().length > 0)
          const hasAddrStr = !!(loc?.address && String(loc.address).trim().length > 0 && loc.address !== ', ')
          return (hasStreet && hasCity && hasZip) || hasAddrStr
        }
      },
      {
        key: 'regularHours',
        labelKey: 'dash.presenceManagement.score.items.regularHours',
        defaultLabel: 'Horaires d\'ouverture',
        weight: 10,
        tab: 'hours',
        check: loc => (loc?.regularHours?.periods || []).length > 0
      },
      {
        key: 'description',
        labelKey: 'dash.presenceManagement.score.items.description',
        defaultLabel: 'Description de l\'entreprise',
        weight: 8,
        tab: 'profile',
        check: loc => !!(loc?.profile?.description && loc.profile.description.trim())
      },
      {
        key: 'website',
        labelKey: 'dash.presenceManagement.score.items.website',
        defaultLabel: 'Site web',
        weight: 7,
        tab: 'profile',
        check: loc => !!(loc?.websiteUri && loc.websiteUri.trim())
      },
      {
        key: 'logo',
        labelKey: 'dash.presenceManagement.score.items.logo',
        defaultLabel: 'Logo de l\'établissement',
        weight: 5,
        tab: 'profile',
        check: loc => !!(loc?.avatar || loc?.metadata?.profilePhotoUri || loc?.profilePhoto)
      },
      {
        key: 'cover',
        labelKey: 'dash.presenceManagement.score.items.cover',
        defaultLabel: 'Photo de couverture',
        weight: 5,
        tab: 'profile',
        check: loc => !!(loc?.coverPhoto || loc?.metadata?.coverPhotoUri)
      },
      {
        key: 'specialHours',
        labelKey: 'dash.presenceManagement.score.items.specialHours',
        defaultLabel: 'Jours fériés & congés',
        weight: 3,
        tab: 'specialHours',
        check: loc => (loc?.specialHours?.specialHourPeriods || []).length > 0
      },
      {
        key: 'attributes',
        labelKey: 'dash.presenceManagement.score.items.attributes',
        defaultLabel: 'Services & Attributs',
        weight: 2,
        tab: 'activity',
        check: loc => (loc?.attributes || []).length > 0 || (loc?.categories?.primaryCategory?.serviceTypes || []).length > 0
      }
    ]
  }

  const items = CRITERIA.map(c => ({
    ...c,
    passed: c.check(location)
  }))

  const hitsWeight = items.reduce((sum, item) => item.passed ? sum + item.weight : sum, 0)
  const score = Math.max(0, Math.min(100, Math.round(hitsWeight)))

  let band = 'low'
  if (score === 100) band = 'full'
  else if (score >= 50) band = 'medium'

  const missingItems = items.filter(i => !i.passed)

  return {
    score,
    band,
    items,
    missingItems,
    missingCount: missingItems.length
  }
}

export function computeCompletionScore(location) {
  return computeCompletionAudit(location).score
}

export function getCompletionBand(score) {
  if (score === 100) return 'full'
  if (score >= 50) return 'medium'
  return 'low'
}

function getAddressLabel(location) {
  const lines = location?.storefrontAddress?.addressLines || []
  const postalCode = location?.storefrontAddress?.postalCode || ''
  const locality = location?.storefrontAddress?.locality || ''
  return [lines.join(' '), [postalCode, locality].filter(Boolean).join(' ')].filter(Boolean).join(', ')
}

function getSpecialDaysThisWeek(location) {
  const periods = location?.specialHours?.specialHourPeriods || []
  const pad = n => String(n).padStart(2, '0')
  const daysThisWeek = []

  const now = new Date()
  const currentDay = now.getDay() // 0 is Sunday, 1 is Monday...
  const diffToMon = (currentDay === 0 ? -6 : 1 - currentDay)
  
  const mon = new Date(now)
  mon.setDate(now.getDate() + diffToMon)
  mon.setHours(0,0,0,0)

  const DAY_NAMES = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']

  for (let p of periods) {
    if (!p.startDate) continue
    const dateStr = `${p.startDate.year}-${pad(p.startDate.month)}-${pad(p.startDate.day)}`
    const targetDate = new Date(p.startDate.year, p.startDate.month - 1, p.startDate.day)
    
    const dayDiff = Math.floor((targetDate - mon) / (1000 * 60 * 60 * 24))
    if (dayDiff >= 0 && dayDiff <= 6) {
      const dayName = DAY_NAMES[targetDate.getDay()]
      if (!daysThisWeek.includes(dayName)) {
        daysThisWeek.push(dayName)
      }
    }
  }
  return daysThisWeek
}

function normalizeLocation(location, index) {
  const audit = computeCompletionAudit(location)
  const periods = location?.regularHours?.periods || []
  const validRegularDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
  const openDays = Array.from(
    new Set(periods.filter(p => p && validRegularDays.includes(p.openDay)).map(p => p.openDay))
  ).sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b))

  const specialDaysThisWeek = getSpecialDaysThisWeek(location)
  const hasSpecialHoursThisWeek = specialDaysThisWeek.length > 0

  const avatar = location?.avatar || 
                 location?.imageUrl || 
                 location?.profilePhoto || 
                 location?.profile_picture_url || 
                 location?.metadata?.profilePhotoUri || 
                 (location?.media || []).find(m => m.category === 'LOGO' || m.category === 'PROFILE')?.sourceUrl ||
                 (location?.media || []).find(m => m.category === 'LOGO' || m.category === 'PROFILE')?.googleUrl ||
                 require('@/assets/img/template_image_placeholder.jpg')

  const cover = location?.coverPhoto || 
                location?.coverImageUrl || 
                location?.metadata?.coverPhotoUri || 
                (location?.media || []).find(m => m.category === 'COVER')?.sourceUrl ||
                (location?.media || []).find(m => m.category === 'COVER')?.googleUrl ||
                require('@/assets/img/template_image_placeholder.jpg')

  const net = location?.network || (Array.isArray(location?.networks) && location.networks[0]) || 'google'

  return {
    id: location?.name || location?.id || `location-${index}`,
    localPageId: location?.localPageId || null,
    network: String(net).toLowerCase(),
    networks: location?.networks || [String(net).toLowerCase()],
    title: location?.title || location?.name || '',
    address: getAddressLabel(location),
    imageUrl: avatar,
    coverImageUrl: cover,
    additionalPhotos: location?.additionalPhotos || (location?.media || []).filter(m => m.category === 'ADDITIONAL' || !m.category).map(m => m.sourceUrl || m.googleUrl || m.url).filter(Boolean),
    completionScore: audit.score,
    completionBand: audit.band,
    missingItems: audit.missingItems,
    missingCount: audit.missingCount,
    completionItems: audit.items,
    openDays,
    specialDaysThisWeek,
    hasSpecialHoursThisWeek,
    username: location?.username || location?.raw?.username || '',
    followersCount: location?.followersCount !== undefined ? location.followersCount : (location?.raw?.followers_count !== undefined ? location.raw.followers_count : null),
    followsCount: location?.followsCount !== undefined ? location.followsCount : (location?.raw?.follows_count !== undefined ? location.raw.follows_count : null),
    facebookUri: location?.facebookUri || location?.raw?.facebookUri || location?.socialProfiles?.facebook || null,
    instagramUri: location?.instagramUri || location?.raw?.instagramUri || location?.socialProfiles?.instagram || null,
    raw: location
  }
}

/**
 * Converts the UI special-hours payload (holidays + vacation periods) to the GBP
 * specialHours.specialHourPeriods array format.
 *
 * Only holidays that the user explicitly opened (isExpanded) are included, so
 * untouched holidays keep their inherited regular hours on GBP.
 *
 * Vacation periods are always saved as closed date ranges.
 *
 * @param {Array} holidays       - Holiday objects from BulkSpecialHoursEditor
 * @param {Array} vacationPeriods - Vacation period objects { startDate, endDate, name }
 * @returns {Array} GBP specialHourPeriods
 */
function buildSpecialHourPeriods(holidays, vacationPeriods) {
  const periods = []

  holidays.forEach(holiday => {
    if (!holiday.isExpanded) return

    const [year, month, day] = holiday.date.split('-').map(Number)
    const startDate = { year, month, day }

    if (!holiday.isOpen) {
      periods.push({ startDate, closed: true })
      return
    }

    if (holiday.isAllDay) {
      periods.push({ startDate, openTime: '00:00', closeTime: '00:00', closed: false })
      return
    }

    holiday.slots.forEach(slot => {
      periods.push({ startDate, openTime: slot.from, closeTime: slot.to, closed: false })
    })
  })

  vacationPeriods.forEach(period => {
    if (!period.startDate || !period.endDate) return
    const [sy, sm, sd] = period.startDate.split('-').map(Number)
    const [ey, em, ed] = period.endDate.split('-').map(Number)
    periods.push({
      startDate: { year: sy, month: sm, day: sd },
      endDate: { year: ey, month: em, day: ed },
      closed: true
    })
  })

  return periods
}

/**
 * @param {Object} schedule - UI schedule: { MONDAY: { isOpen, isAllDay, slots: [{from, to}] }, ... }
 * @returns {Array} GBP regularHours.periods — allDay periods use 00:00/00:00 (GBP convention)
 */
function scheduleToGbpPeriods(schedule) {
  const periods = []
  Object.entries(schedule).forEach(([dayKey, day]) => {
    if (!day.isOpen) return
    if (day.isAllDay) {
      periods.push({ openDay: dayKey, openTime: '00:00', closeDay: dayKey, closeTime: '00:00' })
      return
    }
    day.slots.forEach(slot => {
      periods.push({ openDay: dayKey, openTime: slot.from, closeDay: dayKey, closeTime: slot.to })
    })
  })
  return periods
}

export default {
  namespaced: true,

  state: {
    locations: [],
    searchTerm: '',
    sortBy: 'name',
    sortOrder: 'asc',
    isStreaming: false,
    totalPagesExpected: 0
  },

  mutations: {
    setLocations(state, locations) {
      state.locations = locations
    },

    setStreaming(state, isStreaming) {
      state.isStreaming = isStreaming
    },

    setTotalPagesExpected(state, total) {
      state.totalPagesExpected = total
    },

    setSearchTerm(state, searchTerm) {
      state.searchTerm = searchTerm
    },

    setSort(state, { sortBy, sortOrder }) {
      state.sortBy = sortBy
      state.sortOrder = sortOrder
    },

    /**
     * Updates a single location's regular hours and recomputes its derived fields
     * (openDays, completionScore, completionBand) after a bulk-hours save.
     */
    updateLocationHours(state, { locationId, periods }) {
      const idx = state.locations.findIndex(loc => loc.id === locationId)
      if (idx === -1) return

      const location = state.locations[idx]

      if (location.raw.regularHours) {
        location.raw.regularHours.periods = periods
      } else {
        location.raw.regularHours = { periods }
      }

      const openDays = Array.from(
        new Set(periods.map(p => p.openDay).filter(Boolean))
      ).sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b))

      location.openDays = openDays
      location.completionScore = computeCompletionScore(location.raw)
      location.completionBand = getCompletionBand(location.completionScore)
    },

    updateLocationSpecialHours(state, { locationId, specialHourPeriods }) {
      const idx = state.locations.findIndex(loc => loc.id === locationId)
      if (idx === -1) return

      const location = state.locations[idx]

      if (location.raw.specialHours) {
        location.raw.specialHours.specialHourPeriods = specialHourPeriods
      } else {
        location.raw.specialHours = { specialHourPeriods }
      }

      location.specialDaysThisWeek = getSpecialDaysThisWeek(location.raw)
      location.hasSpecialHoursThisWeek = location.specialDaysThisWeek.length > 0
      location.completionScore = computeCompletionScore(location.raw)
      location.completionBand = getCompletionBand(location.completionScore)
    },

    updateLocationData(state, { locationId, rawData }) {
      const idx = state.locations.findIndex(loc => loc.id === locationId)
      if (idx === -1) return

      const location = state.locations[idx]
      Object.assign(location.raw, rawData)

      if (rawData.title) location.title = rawData.title
      location.address = getAddressLabel(location.raw)

      const periods = location.raw?.regularHours?.periods || []
      const validRegularDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
      location.openDays = Array.from(
        new Set(periods.filter(p => p && validRegularDays.includes(p.openDay)).map(p => p.openDay))
      ).sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b))

      location.specialDaysThisWeek = getSpecialDaysThisWeek(location.raw)
      location.hasSpecialHoursThisWeek = location.specialDaysThisWeek.length > 0
      location.completionScore = computeCompletionScore(location.raw)
      location.completionBand = getCompletionBand(location.completionScore)
    },

    addOrUpdateLocationStream(state, locationObj) {
      const normalized = normalizeLocation(locationObj, state.locations.length)
      const existingIdx = state.locations.findIndex(
        l => l.id === normalized.id || (l.localPageId && normalized.localPageId && l.localPageId === normalized.localPageId)
      )
      if (existingIdx >= 0) {
        state.locations.splice(existingIdx, 1, normalized)
      } else {
        state.locations.push(normalized)
      }
    }
  },

  actions: {
    // Fallback direct GET locations from API
    async fetchLocationsFallback({ commit }) {
      try {
        const token = localStorage.getItem('token')
        const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}/presence-management/locations`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (data.success && data.locations) {
          const normalized = data.locations.map((location, index) => normalizeLocation(location, index))
          commit('setLocations', normalized)
        }
      } catch (err) {
        console.error('Error fetching fallback locations:', err)
      }
    },

    // GET Locations from API via SSE streaming with resilient fallback
    async fetchLocations({ commit, state, dispatch }) {
      commit('setStreaming', true)
      let streamHasError = false
      let hasReceivedLocations = false

      try {
        const token = localStorage.getItem('token')
        const response = await fetch(`${process.env.VUE_APP_API_HOST}/presence-management/locations/stream`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })

        if (!response.ok || !response.body) {
          await dispatch('fetchLocationsFallback')
          commit('setStreaming', false)
          return
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''

        // eslint-disable-next-line no-constant-condition
        while (true) {
          const { value, done } = await reader.read()
          if (done) break

          buffer += decoder.decode(value, { stream: true })
          const chunks = buffer.split('\n\n')
          buffer = chunks.pop() || ''

          for (const chunk of chunks) {
            if (!chunk.trim()) continue
            let eventName = 'message'
            let eventData = ''

            for (const line of chunk.split('\n')) {
              if (line.startsWith('event:')) {
                eventName = line.replace(/^event:\s*/, '').trim()
              } else if (line.startsWith('data:')) {
                eventData = line.replace(/^data:\s*/, '').trim()
              }
            }

            if (eventName === 'init' && eventData) {
              try {
                const initObj = JSON.parse(eventData)
                if (initObj.totalPages) commit('setTotalPagesExpected', initObj.totalPages)
              } catch (e) {
                // Ignore init parse error
              }
            } else if (eventName === 'location' && eventData) {
              try {
                const locationObj = JSON.parse(eventData)
                commit('addOrUpdateLocationStream', locationObj)
                hasReceivedLocations = true
              } catch (e) {
                console.error('Error parsing SSE location:', e)
              }
            } else if (eventName === 'error') {
              streamHasError = true
              commit('setStreaming', false)
            } else if (eventName === 'done') {
              commit('setStreaming', false)
            }
          }
        }

        // If the stream ended with an error or without delivering any locations, trigger fallback
        if (streamHasError || (!hasReceivedLocations && (!state.locations || state.locations.length === 0))) {
          await dispatch('fetchLocationsFallback')
        }
      } catch (error) {
        console.error('Error streaming locations, triggering fallback:', error)
        await dispatch('fetchLocationsFallback')
      } finally {
        commit('setStreaming', false)
      }
    },

    // Temp method to prevent broking hook created()
    initMockLocations({ dispatch }) {
      return dispatch('fetchLocations')
    },

    updateSearchTerm({ commit }, searchTerm) {
      commit('setSearchTerm', searchTerm)
    },

    toggleSort({ state, commit }, sortBy) {
      const isSameSort = state.sortBy === sortBy
      const sortOrder = isSameSort && state.sortOrder === 'asc' ? 'desc' : 'asc'
      commit('setSort', { sortBy, sortOrder })
    },

    // Massive save of schedule (Google + Facebook)
    async saveBulkSchedule({ state, commit, rootGetters }, { schedule }) {
      const periods = scheduleToGbpPeriods(schedule)
      const selectedPageIds = rootGetters['selectPage/selectPagePageSelected'] || []
      const selectedLocations = state.locations.filter(location => {
        const isSelected = !location.localPageId || selectedPageIds.includes(location.localPageId)
        const net = String(location.network || (Array.isArray(location.networks) && location.networks[0]) || 'google').toLowerCase()
        return isSelected && (net === 'google' || net === 'facebook')
      })
      const locationIds = selectedLocations.map(location => location.id)

      if (!locationIds.length) return []

      try {
        const {data} = await axios.post(
          `${process.env.VUE_APP_API_HOST}/presence-management/locations/bulk`,
          {
            locationIds,
            updateMask: 'regularHours',
            data: {
              regularHours: { periods }
            }
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
          }
        )

        if (data.success && data.results) {
          // Updates only the successful records locally
          data.results.forEach(result => {
            if (result.success) {
              commit('updateLocationHours', { locationId: result.networkId, periods })
            } else {
              console.error(`Failed to update location ${result.networkId}:`, result.error)
            }
          })
          return data.results
        }
        return []
      } catch (error) {
        console.error('Error saving bulk schedule:', error)
        throw error
      }
    },

    // Massive save of special hours (holidays + vacation periods) (Google only)
    async saveBulkSpecialHours({ state, commit, rootGetters }, { holidays, vacationPeriods }) {
      const specialHourPeriods = buildSpecialHourPeriods(holidays, vacationPeriods)
      const selectedPageIds = rootGetters['selectPage/selectPagePageSelected'] || []
      const selectedLocations = state.locations.filter(location => {
        const isSelected = !location.localPageId || selectedPageIds.includes(location.localPageId)
        const net = String(location.network || (Array.isArray(location.networks) && location.networks[0]) || 'google').toLowerCase()
        return isSelected && (net === 'google')
      })
      const locationIds = selectedLocations.map(location => location.id)

      if (!locationIds.length) return []

      try {
        const {data} = await axios.post(
          `${process.env.VUE_APP_API_HOST}/presence-management/locations/bulk`,
          {
            locationIds,
            updateMask: 'specialHours',
            data: {
              specialHours: { specialHourPeriods }
            }
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
          }
        )
        
        if (data.success && data.results) {
          data.results.forEach(result => {
            if (result.success) {
              commit('updateLocationSpecialHours', { locationId: result.networkId, specialHourPeriods })
            } else {
              console.error(`Failed to update special hours for location ${result.networkId}:`, result.error)
            }
          })
          return data.results
        }
        return []
      } catch (error) {
        console.error('Error saving bulk special hours:', error)
        throw error
      }
    },

    // Unitary save of a single location PATCH
    async saveLocationData({ commit }, { locationId, rawData }) {
      const shortId = locationId.replace('locations/', '')

      const paths = []
      if (rawData.title) paths.push('title')
      if (rawData.profile && rawData.profile.description !== undefined) paths.push('profile.description')          
      if (rawData.phoneNumbers && rawData.phoneNumbers.primaryPhone && rawData.phoneNumbers.primaryPhone.trim()) {
        paths.push('phoneNumbers.primaryPhone')
      }
      if (rawData.storefrontAddress && 
          rawData.storefrontAddress.addressLines && 
          rawData.storefrontAddress.addressLines.length > 0 && 
          rawData.storefrontAddress.postalCode && 
          rawData.storefrontAddress.locality) {
        paths.push('storefrontAddress')
      }
      if (rawData.categories && rawData.categories.primaryCategory && rawData.categories.primaryCategory.name) {   
        paths.push('categories')
      }
      if (rawData.regularHours) paths.push('regularHours')
      if (rawData.specialHours) paths.push('specialHours')
      if (rawData.serviceItems) paths.push('serviceItems')
      if (rawData.websiteUri !== undefined) paths.push('websiteUri')
      if (rawData.latlng) paths.push('latlng')

      const network = String(rawData.network || (Array.isArray(rawData.networks) && rawData.networks[0]) || 'google').toLowerCase()
      if (network === 'facebook' || network === 'instagram') {
        if (rawData.email !== undefined) paths.push('email')
        if (rawData.whatsappNumber !== undefined) paths.push('whatsappNumber')
        if (rawData.foundingDate !== undefined) paths.push('foundingDate')
        if (rawData.privacyPolicyUrl !== undefined) paths.push('privacyPolicyUrl')
        if (rawData.impressum !== undefined) paths.push('impressum')
        if (rawData.customLinks !== undefined) paths.push('customLinks')
        if (rawData.priceRange !== undefined) paths.push('priceRange')
        if (rawData.specialties !== undefined) paths.push('specialties')
      }

      const updateMask = paths.join(',')

      try {
        const {data} = await axios.patch(
          `${process.env.VUE_APP_API_HOST}/presence-management/locations/${shortId}?updateMask=${updateMask}`,
          rawData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
          }
        )

        if (data.success && data.location) {
          commit('updateLocationData', { locationId, rawData: data.location })
          return { success: true }
        }
        return { success: false, error: data.error || data.message }
      } catch (error) {
        console.error('Error saving location data:', error)
        const serverError = error.response?.data?.error || error.response?.data?.message || error.message
        return { success: false, error: serverError }
      }
    },

    async fetchLocationReviews({ commit }, { locationId }) {
      const shortId = (locationId || '').replace(/^locations\//, '')
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_HOST}/presence-management/locations/${shortId}/reviews`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        )
        if (data.success) {
          return {
            success: true,
            reviews: data.reviews || [],
            totalReviewCount: data.totalReviewCount || 0,
            averageRating: data.averageRating || 0,
            positiveCount: data.positiveCount || 0,
            negativeCount: data.negativeCount || 0,
            recommendationRate: data.recommendationRate || 0,
            overallStarRating: data.overallStarRating || 0,
            ratingCount: data.ratingCount || 0
          }
        }
        return { success: false, reviews: [], error: data.error }
      } catch (error) {
        console.error('Error fetching location reviews:', error)
        return { success: false, reviews: [], error: error.message }
      }
    },

    async replyToLocationReview({ commit }, { locationId, reviewName, comment, storyId }) {
      const shortId = (locationId || '').replace(/^locations\//, '')
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_HOST}/presence-management/locations/${shortId}/reviews/reply`,
          { reviewName, comment, storyId },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        )
        if (data.success) return { success: true, reply: data.reply }
        return { success: false, error: data.error }
      } catch (error) {
        console.error('Error replying to location review:', error)
        return { success: false, error: error.message }
      }
    },

    async deleteLocationReviewReply({ commit }, { locationId, reviewName, replyId }) {
      const shortId = (locationId || '').replace(/^locations\//, '')
      try {
        const { data } = await axios.delete(
          `${process.env.VUE_APP_API_HOST}/presence-management/locations/${shortId}/reviews/reply`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            data: { reviewName, replyId }
          }
        )
        if (data.success) return { success: true }
        return { success: false, error: data.error }
      } catch (error) {
        console.error('Error deleting location review reply:', error)
        return { success: false, error: error.message }
      }
    },

    async generateAiReviewReply({ commit }, { locationId, reviewComment, starRating, reviewerName, recommendationType }) {
      const shortId = (locationId || '').replace(/^locations\//, '')
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_HOST}/presence-management/locations/${shortId}/reviews/generate-ai-reply`,
          { reviewComment, starRating, reviewerName, recommendationType },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        )
        if (data.success && data.replyText) {
          return { success: true, replyText: data.replyText }
        }
        return { success: false, error: data.error }
      } catch (error) {
        console.error('Error generating AI review reply:', error)
        return { success: false, error: error.message }
      }
    }
  },

  getters: {
    locationById: (state) => (id) => {
      return state.locations.find(loc => loc.id === id) || null
    },

    filteredSortedLocations(state) {
      const query = (state.searchTerm || '').trim().toLowerCase()
      const filtered = !query
        ? state.locations
        : state.locations.filter(location => {
            const title = (location?.title || '').toLowerCase()
            const address = (location?.address || '').toLowerCase()
            return title.includes(query) || address.includes(query)
          })

      return [...filtered].sort((left, right) => {
        const direction = state.sortOrder === 'asc' ? 1 : -1

        if (state.sortBy === 'completion') {
          return (left.completionScore - right.completionScore) * direction
        }

        if (state.sortBy === 'network') {
          const leftNet = String(left.network || '').toLowerCase()
          const rightNet = String(right.network || '').toLowerCase()
          return leftNet.localeCompare(rightNet, 'fr', { sensitivity: 'base' }) * direction
        }

        return left.title.localeCompare(right.title, 'fr', { sensitivity: 'base' }) * direction
      })
    },

    totalLocations(state) {
      return state.locations.length
    }
  }
}
